import React from 'react';
import Navbar from '../dashboard/Navbar';
import Sidebar from '../dashboard/Sidebar';
import { useSidebar } from '../../context/SidebarContext';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
  const { isCollapsed } = useSidebar();

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 scrollbar-hide">
      <Navbar />
      <div className="main-layout">
        <Sidebar />
        <main className={`${isCollapsed ? 'mr-16' : 'mr-64'} main-content transition-all duration-300 scrollbar-hide`}>
          <div className="pt-16">
            <div className="pt-2 px-6 pb-24">
              <div className="content">
                <Outlet />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
